import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalAgregarAnotacionesComponent } from './modal-agregar-anotaciones.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [ModalAgregarAnotacionesComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class ModalAgregarAnotacionesModule { }
